<template>
  <div class="footer">

    <ul>
      <li>
        <router-link to="/home">
          <i class="xi-home"></i>
        </router-link>
      </li>
      <li>
        <router-link to="/about">
          <i class="xi-user"></i>
        </router-link>
      </li>
      <li>
        <router-link to="/works">
          <i class="xi-camera"></i>
        </router-link>
      </li>
      <li>
        <router-link to="whatido">
          <i class="xi-telegram"></i>
        </router-link>
      </li>
      <li>
        <router-link to="/contact">
          <i class="xi-mail"></i>
        </router-link>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
  @import '../../sass/partials/_variable.scss';

  .footer{
    width: 100%;
    height: 70px;
    position: fixed; left: 0; bottom: 0;
    z-index: 10;
    background-color: $bg-color3;    
    border-top: 1px solid #ccc;

    ul{
      width: 100%;
      height: 100%;
      display: flex;

      li{
        flex: 1;

        a{
          display: block;
          width: 100%;
          height: 100%;
          line-height: 70px;
          text-align: center;
          font-size: 3rem;
          color: $typo3;

          &:hover{ color: $primary1; }
        }
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/component/Footer.vue